import Controller from '@ember/controller';
import { action, setProperties } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import logger from 'donor-elf-web/lib/logger';

export default class IntervarsityProspectsProcessingController extends Controller {
  @service contactsCache;
  @service fundsService;
  @service router;
  @service store;

  @tracked checkFundUploadProgress = false;
  @tracked hasError = false;

  reset() {
    setProperties(this, {
      checkFundUploadProgress: false,
      hasError: false,
    });
  }

  @action
  handleS3UploadComplete(s3Upload) {
    this.fundsService.confirmValidFundToken().then(() => {
      let importRecord = this.store.createRecord(
        'intervarsity-prospects-import',
        {
          s3Key: s3Upload.key,
        },
      );
      importRecord.save().then(() => {
        this.checkFundUploadProgress = true;
      });
    });
  }

  @action
  handleS3UploadError() {
    logger.error(
      'There was an error uploading the InterVarsity Prospects file',
    );
  }

  @action
  onFundUploadComplete() {
    this.contactsCache.loadContacts({ forceLoad: true }).then(() => {
      this.router.transitionTo(
        'funds.fund.import.intervarsity-prospects.complete',
      );
    });
  }

  @action
  onFundUploadError() {
    this.hasError = true;
  }
}
